import React from 'react';
import ha1 from '../images/vehicleimg/HamptonAmbassador/A1.jpg';
import ha2 from '../images/vehicleimg/HamptonAmbassador/A2.jpg';
import ha3 from '../images/vehicleimg/HamptonAmbassador/A3.jpg';
import ha4 from '../images/vehicleimg/HamptonAmbassador/A4.jpg';
import ha5 from '../images/vehicleimg/HamptonAmbassador/A5.jpg';
import ha6 from '../images/vehicleimg/HamptonAmbassador/A6.jpg';
import ha7 from '../images/vehicleimg/HamptonAmbassador/A7.jpg';
import hj1 from '../images/vehicleimg/HamptonJitney/J1.jpg';
import hj2 from '../images/vehicleimg/HamptonJitney/J2.jpg';
import hj3 from '../images/vehicleimg/HamptonJitney/J3.jpg';
import hj4 from '../images/vehicleimg/HamptonJitney/J4.jpg';
import hj5 from '../images/vehicleimg/HamptonJitney/J5.jpg';
import hj6 from '../images/vehicleimg/HamptonJitney/J6.jpg';
import hj7 from '../images/vehicleimg/HamptonJitney/J7.jpg';
import nt1 from '../images/vehicleimg/NorthForkTrolley/NorthForkTrolley_04.jpg';
import nt2 from '../images/vehicleimg/NorthForkTrolley/NorthForkTrolley_11.jpg';
import nt3 from '../images/vehicleimg/NorthForkTrolley/NorthForkTrolley_23.jpg';
import nt4 from '../images/vehicleimg/NorthForkTrolley/NorthForkTrolley_25.jpg';
import nt7 from '../images/vehicleimg/NorthForkTrolley/NorthForkTrolley_18.jpg';
import hll1 from '../images/vehicleimg/HamptonLuxuryLiner/1.png';
import hll2 from '../images/vehicleimg/HamptonLuxuryLiner/2.jpg';

import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import { PageLayout } from '../components/PageLayout';

const VehicleFleet = () => {
  document.title = "Vehicle Fleet - Hampton Jitney Charters";
  return (
    <PageLayout>
      <div className="flex grow flex-wrap flex-row">
        <div className="border border-black rounded-lg p-4 bg-white bg-opacity-75 mx-4 my-4">
          <h1 className="text-4xl font-bold mb-4 text-center">Vehicle Fleet</h1>
          <div class="bg-green-200 border-t border-b border-green-500 text-green-700 px-4 py-3" role="alert">
            <p class="font-bold">From elegant to economical</p>
            <p class="text-md">We offer a choice of vehicles and services designed to meet your transportation needs,
             all at competetive prices. Browse our image galleries below to see some of the vehicles in our fleet.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-[80%] mx-auto mt-10">
            <div className="flex flex-col items-center">
              <p className="text-2xl font-bold py-2">
                Hampton Jitney
              </p>
              <Carousel 
                showArrows={true} 
                infiniteLoop={true} 
                showThumbs={false} 
                showStatus={false} 
                className="flex justify-between mt-4 mx-auto mt-20"
              >
                <img src={hj4} alt="HAMPTON JITNEY Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" />
                <img src={hj1} alt="HAMPTON JITNEY Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" />
                <img src={hj2} alt="HAMPTON JITNEY Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" />
                <img src={hj3} alt="HAMPTON JITNEY Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" />
                <img src={hj5} alt="HAMPTON JITNEY Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" />
                <img src={hj6} alt="HAMPTON JITNEY Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" />
                <img src={hj7} alt="HAMPTON JITNEY Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" />
              </Carousel>
            </div>
            <div className="flex flex-col items-center">
              <p className="text-2xl font-bold py-2">
                Hampton Ambassador
              </p>
              <Carousel 
                showArrows={true} 
                infiniteLoop={true}
                showThumbs={false} 
                showStatus={false} 
                className="flex justify-between mt-4 mx-auto mt-20"
              >
                <img src={ha3} alt="HAMPTON AMBASSADOR Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md"  />
                <img src={ha1} alt="HAMPTON AMBASSADOR Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md"  />
                <img src={ha2} alt="HAMPTON AMBASSADOR Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md"  />
                <img src={ha4} alt="HAMPTON AMBASSADOR Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md"  />
                <img src={ha5} alt="HAMPTON AMBASSADOR Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md"  />
                <img src={ha6} alt="HAMPTON AMBASSADOR Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md"  />
                <img src={ha7} alt="HAMPTON AMBASSADOR Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md"  />
              </Carousel>
            </div>
            <div className="flex flex-col items-center">
              <p className="text-2xl font-bold py-2">
                Northfork Trolley
              </p>
              <Carousel 
                showArrows={true} 
                infiniteLoop={true} 
                showThumbs={false} 
                showStatus={false} 
                className="flex justify-between mt-4 mx-auto mt-20"
              >
                <img src={nt7} alt="NORTHFOLK TROLLEY Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" />
                <img src={nt1} alt="NORTHFOLK TROLLEY Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" />
                <img src={nt2} alt="NORTHFOLK TROLLEY Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" />
                <img src={nt3} alt="NORTHFOLK TROLLEY Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" />
                <img src={nt4} alt="NORTHFOLK TROLLEY Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" />
              </Carousel>
            </div>
            <div className="flex flex-col items-center">
              <p className="text-2xl font-bold py-2">
                Hampton Luxury Liner
              </p>
              <Carousel 
                showArrows={true} 
                infiniteLoop={true} 
                showThumbs={false} 
                showStatus={false} 
                className="flex justify-between mt-4 mx-auto mt-20"
              >
                <img src={hll2} alt="HAMPTON LUXURY LINER Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" />
                <img src={hll1} alt="HAMPTON LUXURY LINER Carousel" className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" />
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default VehicleFleet;
